(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_e83f94a"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const marquee = document.querySelector('.ai-reviews-marquee-{{ ai_gen_id }}');
    const container = marquee.querySelector('.ai-reviews-marquee-container-{{ ai_gen_id }}');

    let isDown = false;
    let startX;
    let scrollLeft;

    marquee.addEventListener('mousedown', (e) => {
      isDown = true;
      marquee.classList.add('active');
      container.style.animationPlayState = 'paused'; // توقف الأنيميشن أثناء السحب
      startX = e.pageX - marquee.offsetLeft;
      scrollLeft = marquee.scrollLeft;
    });

    marquee.addEventListener('mouseleave', () => {
      isDown = false;
      marquee.classList.remove('active');
      container.style.animationPlayState = 'running'; // رجّع الأنيميشن
    });

    marquee.addEventListener('mouseup', () => {
      isDown = false;
      marquee.classList.remove('active');
      container.style.animationPlayState = 'running';
    });

    marquee.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - marquee.offsetLeft;
      const walk = (x - startX) * 1;
      marquee.scrollLeft = scrollLeft - walk;
    });

    marquee.addEventListener('touchstart', (e) => {
      isDown = true;
      container.style.animationPlayState = 'paused';
      startX = e.touches[0].pageX - marquee.offsetLeft;
      scrollLeft = marquee.scrollLeft;
    });

    marquee.addEventListener('touchend', () => {
      isDown = false;
      container.style.animationPlayState = 'running';
    });

    marquee.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - marquee.offsetLeft;
      const walk = (x - startX) * 1;
      marquee.scrollLeft = scrollLeft - walk;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
